export default __webpack_public_path__ + "static/media/video_poster.a272bbcc.jpg";